import styled from 'styled-components';

export const HeaderContainer = styled.div`
  margin-bottom: 32px;
  margin-left: 10px;
`;

export const PageTitle = styled.h2`
  color: #102e4c;
  font-family: 'Montserrat SemiBold';
  font-size: 28px;
  letter-spacing: 2px;
  margin-bottom: 24px;
`;

export const PageLine = styled.div`
  border-bottom: 1px solid var(--grey-50, #797E86);
  height: 3px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row nowrap;
`;
